module.exports = __webpack_public_path__ + "img/map_13.362ae8da.png";